import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useAuth, formatErr } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await register(f.email, f.password, f.name); toast.success("Account created"); nav("/dashboard"); }
    catch (ex) { setErr(formatErr(ex.response?.data?.detail) || ex.message); }
    finally { setBusy(false); }
  };
  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      <Nav />
      <main className="container-hs py-16 max-w-md">
        <h1 className="font-display text-3xl mb-6">Create your account</h1>
        <form onSubmit={submit} className="card-hs p-6 space-y-4">
          <div><label className="hs-label">Name (optional)</label><input data-testid="reg-name" className="hs-input" value={f.name} onChange={e => setF({...f, name: e.target.value})} /></div>
          <div><label className="hs-label">Email</label><input data-testid="reg-email" type="email" required className="hs-input" value={f.email} onChange={e => setF({...f, email: e.target.value})} /></div>
          <div><label className="hs-label">Password</label><input data-testid="reg-password" type="password" minLength={6} required className="hs-input" value={f.password} onChange={e => setF({...f, password: e.target.value})} /><p className="hs-hint">At least 6 characters.</p></div>
          {err && <div data-testid="reg-error" className="text-sm text-brand-danger">{err}</div>}
          <button data-testid="reg-submit" disabled={busy} className="btn-primary w-full">{busy ? "Creating…" : "Create account"}</button>
          <button type="button" data-testid="reg-google" onClick={google} className="btn-secondary w-full">Continue with Google</button>
          <p className="text-sm text-brand-muted text-center">Already have an account? <Link to="/login" className="text-brand-accent">Log in</Link></p>
        </form>
      </main>
      <Footer />
    </>
  );
}
